import Keycloak from 'keycloak-js';

/** Realm + resource roles (includes COMPANY). */
export function getUserRoles(keycloak: Keycloak): string[] {
  const realmRoles = keycloak.realmAccess?.roles ?? [];
  const resourceRoles = Object.values(keycloak.resourceAccess ?? {}).flatMap(
    (resource) => resource.roles ?? []
  );
  return Array.from(new Set([...realmRoles, ...resourceRoles]));
}
